<template>
  <div class="popup_in">
    <div class="popup">
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click="$emit('close')"><close-svg /></a>
      </div>
      <div class="title">אישור קיצור תור</div>
      <div class="title--32 no-marge">
        {{ `${app_info.firstName} ${app_info.lastName} ${app_info.passport}` }}
        | {{ app_info.type }}
      </div>
      <div class="title--32 ft--300">
        {{ app_info.notes }}
      </div>
      <div class="shorten_info flex">
        <div class="shorten_info_item">
          תור ישן
          <span class="block bold">{{
            `${$moment(new Date(app_info.start_datetime)).format(
              "HH:mm"
            )}-${$moment(new Date(app_info.end_datetime)).format("HH:mm")}`
          }}</span>
        </div>
        <ArrowBack></ArrowBack>
        <div class="shorten_info_item">
          {{ `תור חדש יקוצר ב-${timeDiff} דק׳` }}
          <span class="block bold">
            {{ newDateText }}
          </span>
        </div>
      </div>
      <a class="bt_blue" href="javascript:void(0)" @click="shortApp">אישור</a>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CloseSvg from "@/assets/img/svg/close-sm.svg";
import ArrowBack from "@/assets/img/svg/arrow_back.svg";
import Error from "@/components/Popups/Error";

export default {
  name: "ShortenHours",
  props: ["appointment", "required_start", "required_end"],
  data() {
    return {
      app_info: "",
      new_date_start: false,
      new_date_end: false
      //hour_to_short: false
    };
  },
  mounted() {
    this.$API
      .getAppointmentInfo(this.appointment.appointment_id)
      .then(res => {
        this.app_info = res.message.appointment;
        this.calcShort();
      })
      .catch(e => {
        this.$modal.show(Error);
      });
  },
  methods: {
    ...mapMutations(["SET_APP_TIME_EDIT", "SET_IS_CHANGE_APP"]),
    async shortApp() {
      let start_date = this.$moment(new Date(this.app_info.start_datetime));
      let end_date = this.$moment(new Date(this.app_info.end_datetime));
      if (this.new_date_start) {
        start_date = this.$moment(this.new_date_start, "DD/MM/YYYY HH:mm");
      }
      if (this.new_date_end) {
        end_date = this.$moment(this.new_date_end, "DD/MM/YYYY HH:mm");
      }

      let appointments = {
        title: "תור",
        id: this.appointment.appointment_id,
        start: start_date.format("YYYY-MM-DDLT:00"),
        end: end_date.format("YYYY-MM-DDLT:00"),
        over_block_id: this.appointment.parent_block_id,
        true_id: ""
      };

      const res = await this.$API.setAppointementsDatetime([appointments]);
      if (!res || res.status !== "OK") {
        this.$modal.show(Error);
      } else {
        await this.SET_APP_TIME_EDIT({
          ...this.$store.getters.appTimeEdit,
          isValid: true
        });
        this.$root.$emit("shortenHours");
        await this.SET_IS_CHANGE_APP(true);
      }
      this.$emit("close");
    },
    calcShort() {
      this.new_date_start = false;
      this.new_date_end = false;

      let wanted_date_start = this.$moment(
        this.required_start,
        "DD/MM/YYYY HH:mm"
      );
      let wanted_date_end = this.$moment(this.required_end, "DD/MM/YYYY HH:mm");

      let appointement_start = this.$moment(
        new Date(this.app_info.start_datetime)
      );
      let appointement_end = this.$moment(new Date(this.app_info.end_datetime));

      if (
        wanted_date_start.isSame(appointement_start) &&
        wanted_date_end.isSame(appointement_end)
      ) {
        //Change start + end
      }
      if (
        !this.new_date_start &&
        wanted_date_start.isAfter(appointement_start) &&
        wanted_date_start.isBefore(appointement_end)
      ) {
        //Change end
        this.new_date_end = wanted_date_start;
      }
      if (
        !this.new_date_end &&
        wanted_date_end.isAfter(appointement_start) &&
        wanted_date_end.isBefore(appointement_end)
      ) {
        //Change start
        this.new_date_start = wanted_date_end;
      }
    }
  },
  computed: {
    ...mapState(["appTimeEdit"]),
    newDateText() {
      let start_date = this.$moment(new Date(this.app_info.start_datetime));
      let end_date = this.$moment(new Date(this.app_info.end_datetime));
      if (this.new_date_start) {
        start_date = this.$moment(this.new_date_start, "DD/MM/YYYY HH:mm");
      }
      if (this.new_date_end) {
        end_date = this.$moment(this.new_date_end, "DD/MM/YYYY HH:mm");
      }
      return start_date.format("HH:mm") + "-" + end_date.format("HH:mm");
    },
    timeDiff() {
      let timediff = 0;
      let start_date = this.$moment(new Date(this.app_info.start_datetime));
      let end_date = this.$moment(new Date(this.app_info.end_datetime));
      if (this.new_date_start) {
        start_date = this.$moment(this.new_date_start, "DD/MM/YYYY HH:mm");
        timediff = start_date.diff(
          this.$moment(new Date(this.app_info.start_datetime)),
          "minutes"
        );
      }
      if (this.new_date_end) {
        end_date = this.$moment(this.new_date_end, "DD/MM/YYYY HH:mm");
        timediff = end_date.diff(
          this.$moment(new Date(this.app_info.end_datetime)),
          "minutes"
        );
      }
      if (timediff < 0) {
        timediff = 0 - timediff;
      }
      return timediff;
    }
  },
  components: {
    CloseSvg,
    ArrowBack
  }
};
</script>

<style scoped></style>
